import {NgModule} from '@angular/core';
import {DropdownComponent} from './dropdown/dropdown.component';
import {CommonModule} from '@angular/common';
import {DropdownFilterPipe} from './dropdown/dropdown-filter.pipe';
import {MultiselectDropdownComponent} from './multiselect-dropdown/multiselect-dropdown.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InlineSVGModule} from 'ng-inline-svg';
import {CustomTableModule, TABLE_CONFIG} from '@innobile/tablemodule';
import {HighlightPipe} from './highlight.pipe';
import {CheckboxComponent} from './checkbox/checkbox.component';
import {PopupComponent} from './popup/popup.component';
import {environment} from '../../environments/environment';
import {TippyDirective} from './tippy.directive';
import {TabLabelTitleDirective} from './tab-label-title.directive';
import {ContextMenuComponent} from './context-menu/context-menu.component';
import {RouterModule} from '@angular/router';
import {BarcodeBaseComponent} from './barcode-base/barcode-base.component';
import {TagPickerComponent} from './tag-picker/tag-picker.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {CdkScrollableModule} from '@angular/cdk/scrolling';
import {TypeaheadComponent} from './autofill/typeahead.component';
import {Popup2Component} from './popup2/popup2.component';
import {TriStateSwitchComponent} from './tri-state-switch/tri-state-switch.component';
import {AutocompleteComponent} from './autocomplete/autocomplete.component';
import {AutocompleteWithCustomComponent} from './autocomplete-with-custom/autocomplete-with-custom.component';
import {ControlRequiredPipe} from './control-required.pipe';
import {SelectedIdsPipe} from './selected-ids.pipe';
import {NumberInputDirective} from './number-input.directive';
import {SwitchComponent} from './switch/switch.component';
import {LanguageService} from "../services/language.service";
import {LanguageSwitchComponent} from './language-switch/language-switch.component';
import {PeriodSelector9Component} from './period-selector9/period-selector9.component';
import {DateInputComponent} from './date-input/date-input.component';
import {ActionDropdownComponent} from './dropdown/action-dropdown/action-dropdown.component';
import {SelectDropdownComponent} from './dropdown/select-dropdown/select-dropdown.component';
import {TileGridComponent} from './tile/components/tile-grid/tile-grid.component';
import {OverlayPanelDirective} from './overlay/overlay-panel.directive';
import {FormatDatePipe} from './pipes/format-date.pipe';
import {ReformatDatePipe} from './pipes/reformat-date.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule.forRoot(),
    CustomTableModule,
    RouterModule,
    OverlayModule,
    CdkScrollableModule,
    OverlayPanelDirective,
    TippyDirective,
    TabLabelTitleDirective,
    PeriodSelector9Component,
    DateInputComponent,
    ActionDropdownComponent,
    SelectDropdownComponent,
    NumberInputDirective,
    SwitchComponent,
    TileGridComponent,
    FormatDatePipe,
    ReformatDatePipe
  ],
  declarations: [
    DropdownComponent,
    DropdownFilterPipe,
    MultiselectDropdownComponent,
    HighlightPipe,
    CheckboxComponent,
    PopupComponent,
    ContextMenuComponent,
    BarcodeBaseComponent,
    TagPickerComponent,
    TypeaheadComponent,
    Popup2Component,
    TriStateSwitchComponent,
    AutocompleteComponent,
    AutocompleteWithCustomComponent,
    ControlRequiredPipe,
    SelectedIdsPipe,
    LanguageSwitchComponent
  ],
  exports: [
    DropdownComponent,
    DropdownFilterPipe,
    MultiselectDropdownComponent,
    InlineSVGModule,
    CustomTableModule,
    OverlayModule,
    OverlayPanelDirective,
    HighlightPipe,
    PopupComponent,
    TippyDirective,
    TabLabelTitleDirective,
    ContextMenuComponent,
    TagPickerComponent,
    TypeaheadComponent,
    Popup2Component,
    TriStateSwitchComponent,
    CheckboxComponent,
    AutocompleteComponent,
    AutocompleteWithCustomComponent,
    ControlRequiredPipe,
    SelectedIdsPipe,
    LanguageSwitchComponent,
    PeriodSelector9Component,
    DateInputComponent,
    ActionDropdownComponent,
    SelectDropdownComponent,
    NumberInputDirective,
    SwitchComponent,
    TileGridComponent,
    FormatDatePipe,
    ReformatDatePipe
  ],
  providers: [{
    provide: TABLE_CONFIG,
    useFactory: initTable,
    deps: [LanguageService]
  }]
})
export class SharedModule { }

export function initTable(languageService: LanguageService) {
  return {backendUrl: environment.apiPrefix, language: languageService.Language}
}
